<egi-modal [show]="show" size="xl" (close)="handleClose()">
  <div header>
    <h2>Creating Issue/Feature</h2>
    <p *ngIf="errorText != ''" class="text-danger">{{ errorText }}</p>
  </div>

  <div class="modal-body pb-1" style="margin-top: -20px">
    <form (submit)="handleSubmit()">
      <div
        class="pt-3 pb-2 mb-2"
        style="
          background-color: #e6ecf5;
          border-radius: 5px;
          max-height: 62vh;
          overflow-y: auto;
          overflow-x: hidden;
        "
      >
        <div class="form-group row align-items-end">
          <label class="col-2" style="text-align: end">Type: </label>
          <ng-select
            class="col-3"
            id="tracker"
            name="tracker"
            [(ngModel)]="issue.tracker_id"
            [items]="trackers"
            bindLabel="name"
            bindValue="id"
          >
          </ng-select>
          <label class="col-1" style="text-align: end">Priority: </label>
          <ng-select
            class="col-3"
            id="tracker"
            name="tracker"
            [(ngModel)]="issue.priority_id"
            [items]="issuePriorities"
            bindLabel="name"
            bindValue="id"
          >
          </ng-select>
        </div>
        <div class="form-group row align-items-end">
          <label class="col-2" style="text-align: end">Title: </label>
          <div class="col-9">
            <input
              style="width: 90%"
              type="text"
              id="subject"
              name="subject"
              [(ngModel)]="issue.subject"
              required
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2" style="text-align: end">Description: </label>
          <div class="col-9">
            <textarea
              style="width: 90%; height: 100px"
              id="description"
              name="description"
              [(ngModel)]="issue.description"
              required
            ></textarea>
          </div>
        </div>
        <div *ngIf="issue.tracker_id != issueIdx" class="form-group row">
          <label class="col-2" style="text-align: end">Impact: </label>
          <div class="col-9">
            <textarea
              style="width: 90%; height: 100px"
              id="impact"
              name="impact"
              [(ngModel)]="issue.impact"
              required
            ></textarea>
          </div>
        </div>

        <div *ngIf="issue.tracker_id === issueIdx">
          <div class="form-group row">
            <label class="col-2" style="text-align: end"
              >Steps to Reproduce:
            </label>
            <div class="col-9">
              <textarea
                style="width: 90%; height: 100px"
                id="steps_to_reproduce"
                name="steps_to_reproduce"
                [(ngModel)]="issue.steps_to_reproduce"
                required
              ></textarea>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2" style="text-align: end"
            >Other Information:
          </label>
          <div class="col-9">
            <textarea
              style="width: 90%; height: 100px"
              id="notes"
              name="notes"
              [(ngModel)]="issue.notes"
              required
            ></textarea>
          </div>
        </div>
        <div
          *ngIf="issue.tracker_id === issueIdx"
          class="form-group row align-items-end"
        >
          <label class="col-2" style="text-align: end"
            >Operating System:
          </label>
          <ng-select
            class="col-3"
            id="operating_system"
            name="operating_system"
            [(ngModel)]="issue.operating_system"
          >
            <ng-option value="Windows">Windows</ng-option>
            <ng-option value="MacOS">MacOS</ng-option>
            <ng-option value="Linux">Linux</ng-option>
            <ng-option value="iOS">iOS</ng-option>
            <ng-option value="Android">Android</ng-option>
          </ng-select>
        </div>
        <div class="form-group row">
          <div class="d-flex align-items-end justify-content-end col-2">
            <label>URL: </label>
          </div>
          <ng-select
            class="col-2"
            id="url-option"
            name="url-option"
            [(ngModel)]="urlSelect"
            [items]="urls"
            (change)="handleUrlChange($event)"
            dropdownPosition="top"
          >
          </ng-select>
          <div class="col-7">
            <input
              [disabled]="urlSelect != 'Other URL'"
              style="width: 88%"
              type="text"
              id="url"
              name="url"
              [(ngModel)]="issue.url"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-2" style="text-align: end">Attachments: </label>
          <div class="col-9">
            <input
              *ngIf="show"
              type="file"
              id="attachments"
              name="attachments"
              (change)="handleFileInput($event)"
              multiple
            />
          </div>
        </div>
      </div>
      <div class="modal-footer pt-1" style="padding-bottom: 0px">
        <button type="submit" class="btn btn-primary">
          <i *ngIf="loading" class="fa fa-spinner fa-spin"></i>
          Submit
        </button>
        <button type="button" class="btn btn-default" (click)="handleClose()">
          Close
        </button>
      </div>
    </form>
  </div>
</egi-modal>
